import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BadgeService } from '../../../../services/gamification/badge.service';
import { BadgeDefinitionDTO } from '../../../../interfaces/gamification/badge-definition.dto';
import { BadgeProgressDTO } from '../../../../interfaces/gamification/badge-progress.dto';
import { BadgeProgressDataDTO } from '../../../../interfaces/gamification/badge-progress-data.dto';

@Component({
  selector: 'gamification-badges',
  templateUrl: 'gamification-badges.component.html',
  styleUrls: ['gamification-badges.component.scss'],
})
export class GamificationBadgesComponent implements OnInit {
  constructor(private badgeService: BadgeService) {}

  @Output() onGrabMovement = new EventEmitter<any>();

  badges: BadgeDefinitionDTO[];
  badgeProgress: BadgeProgressDTO;
  progressData: BadgeProgressDataDTO[];

  badgeDialogVisible = false;

  async ngOnInit() {
    await this.loadDefinitions();
    this.setBadgeProgress();
  }

  setBadgeProgress() {
    this.badgeService.getBadgeProgress().then((res) => {
      this.badgeProgress = res;
      if (this.badgeProgress) {
        this.progressData = res.progressData.sort((x) => x.badge.id);
        console.log('Progress Data: ', this.progressData);
      }
    });
  }

  async loadDefinitions() {
    await this.badgeService.getBadgeDefinitions().then((res) => {
      this.badges = res.sort((x) => x.id);
    });
  }

  showBadgeInfo() {
    this.badgeDialogVisible = true;
  }

  dialogVisibleChanged(event: any) {
    //console.log("Dialogvisible: ", event);
    this.badgeDialogVisible = event;
  }

  grabMovement() {
    this.onGrabMovement.emit();
  }

  getBadgeLineProgress(data: BadgeProgressDataDTO, i: number) {
    let prog = data.progress;
    if (
      (i < this.progressData.length - 1 && this.progressData[i + 1].progress == 0) ||
      data.progress < 100
    ) {
      prog = 0;
    }

    return `${prog}%`;
  }
}
